<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">

        <h2 class="font-weight-bold text-primary mb-7 mt-15">{{news?.newsTitle}}</h2>
       <p class="card-text">{{l('PublishDate')}} :<small class="text-muted bg-white px-2 py-1">{{ news?.publishStateDate.toString()  |date :'HH:mm yyyy LLL dd'}}</small></p>
        <div *ngIf="news?.newsImageId" class="my-10">
            <AttachementViewer height="40rem" width="100%" [ShowFileInfo]="false" [ShowRemoveButton]="false" [Attachement]="newsImageData">
            </AttachementViewer>
        </div>

        <div class=" htmlContainer h5 line-height-xl text-dark-65" [innerHtml]="news?.newsBody">
        </div>
        <div *ngIf="news?.newsVideoId" class="my-10">
            <AttachementViewer height="40rem" width="100%" [ShowFileInfo]="false" [ShowRemoveButton]="false" [Attachement]="newsVideoData">
            </AttachementViewer>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" (click)="Back()">
          {{l('Back')}}
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>
